import React, { useRef, useEffect, forwardRef } from "react";
import useGoogleMapsApi from "./useGoogleMapsApi";

const LocationInput = forwardRef((props, ref) => {
  const { setPlace, val } = props;
  const inputRef = useRef();
  const autocompleteRef = useRef();
  const googleMapsApi = useGoogleMapsApi();

  useEffect(() => {
    if (val) {
      inputRef.current.value = val;
    }
  }, [val]);

  useEffect(() => {
    if (googleMapsApi) {
      autocompleteRef.current = new googleMapsApi.places.Autocomplete(
        inputRef.current,
        { types: [] }
      );
      autocompleteRef.current.addListener("place_changed", () => {
        const place = autocompleteRef.current.getPlace();
        setPlace(place);

        // Do something with the resolved place here (ie store in redux state)
      });
    }
  }, [googleMapsApi]);

  const handleSubmit = (e) => {
    e.preventDefault();

    return false;
  };

  return (
    <form autoComplete="off" onSubmit={handleSubmit} method="post">
      {/* <label htmlFor="location">Location: </label> */}
      <input
        style={{ width: "100%" }}
        name="location"
        aria-label="Search locations"
        ref={inputRef}
        placeholder="Location*"
        autoComplete="off"
        onFocus={(event) => event.target.select()}
      />
    </form>
  );
});

export default LocationInput;
